export default {
  state: {
    test: 'OK',
    loading: false,
    serviceInfo: {},
    SEOReport: {},
    reports: [],
    currentReport: '',
    showHistory: false
  },

  actions: {
    clearServiceInfo (ctx) {
      ctx.commit('storeSEOReport', {})
      ctx.commit('storeServiceInfo', {})
      ctx.commit('storeReports', [])
      ctx.commit('storeCurrentReportDate', '')
    },

    toggleHistoryVisibility (ctx) {
      ctx.commit('setHistoryVisibility', !ctx.state.showHistory)
    }
  },

  mutations: {
    storeCurrentReportDate (state, date) {
      state.currentReport = date
    },

    setHistoryVisibility (state, status) {
      state.showHistory = status
    },

    storeReports (state, reports) {
      state.reports = reports
    },
    storeServiceInfo (state, info) {
      state.serviceInfo = info
    },
    storeSEOReport (state, report) {
      state.SEOReport = report
    },
    storeLoadStatus (state, status) {
      state.loading = status
    }
  },

  getters: {
    SEO (state) {
      return state.SEOReport
    },

    performance (state) {
      return state.SEOReport.performance_score
    }
  }
}
